import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#1877F2\" d=\"M24 12.5c0-6.627-5.373-12-12-12S0 5.873 0 12.5c0 5.99 4.388 10.954 10.125 11.854V15.97H7.078V12.5h3.047V9.856c0-3.007 1.792-4.668 4.533-4.668 1.312 0 2.686.234 2.686.234v2.953H15.83c-1.491 0-1.956.925-1.956 1.875v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.454 24 18.49 24 12.5Z\"></path><path fill=\"#fff\" d=\"m16.671 15.969.532-3.469h-3.328v-2.25c0-.949.465-1.875 1.956-1.875h1.513V5.422s-1.374-.234-2.686-.234c-2.741 0-4.533 1.66-4.533 4.668V12.5H7.078v3.469h3.047v8.385a12.13 12.13 0 0 0 3.75 0V15.97h2.796Z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 .5h24v24H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }